export default {
    delivery: {
        product: {
            tracking: "Tracking"
        }
    }
}